// src/config/env.js
/* eslint-disable import/no-anonymous-default-export */

const isLocalBrowser =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const DEFAULT_API_ENDPOINT = isLocalBrowser
  ? "http://localhost:1337/api"
  : "https://api.bestphonecm.com/api";

const DEFAULT_IMG_ENDPOINT = isLocalBrowser
  ? "http://localhost:1337"
  : "https://api.bestphonecm.com";

const RAW_ENDPOINT =
  process.env.REACT_APP_API_ENDPOINT || DEFAULT_API_ENDPOINT;

const IMG = process.env.REACT_APP_API_ENDPOINT_IMG || DEFAULT_IMG_ENDPOINT;


const ensureProtocol = (u) =>
  /^https?:\/\//i.test(u) ? u : `http://${u}`;

const API_ENDPOINT = ensureProtocol(RAW_ENDPOINT);
const API_ENDPOINT_IMG = ensureProtocol(IMG);

export default {
  api: API_ENDPOINT,
  apiImg: API_ENDPOINT_IMG,
  version: "1.0.0",
};
